import { SizeTypeTokens, IconTokens, IconSizeTokens, ColorTokens, FontSizeTokens, FontFamilyTokens, } from '@voltmoney/schema';
import React, { memo } from 'react';
import Icon from '../icon/Icon';
import Space from '../space/Space';
import Typography from '../typography/Typography';
import { Platform, Pressable, View } from 'react-native';
import ThemeProvider from '@voltmoney/theme';
const HeaderDefaultBase = ({ id, title, triggerAction, onPress, action, isBackButton, trailIcon, bgColor = ColorTokens.White, widgetItem, renderItem, showBottomLine, showBackArrowIcon, }) => {
    const theme = ThemeProvider.getTheme();
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    const handleProfileAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(View, null,
        React.createElement(View, { style: {
                paddingHorizontal: 16,
                paddingVertical: 12,
                borderBottomWidth: 1,
                borderBottomColor: theme.colors[ColorTokens.Grey_Chalk],
                backgroundColor: theme.colors[bgColor],
                marginTop: Platform.OS === 'ios' ? 26 : 0,
            } },
            React.createElement(View, { style: {
                    justifyContent: 'flex-start',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: !!widgetItem ? 16 : 0,
                } },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        flex: 1,
                        alignItems: 'center',
                    } },
                    isBackButton ? (React.createElement(React.Fragment, null,
                        React.createElement(View, { nativeID: id, hitSlop: { top: 48, bottom: 48, left: 48, right: 48 }, style: {
                                alignContent: 'center',
                                justifyContent: 'center',
                                marginTop: showBackArrowIcon ? 0 : 5,
                            } },
                            React.createElement(Pressable, { onPress: handleAction, style: {} },
                                React.createElement(Icon, { name: showBackArrowIcon ? IconTokens.BackArrowIcon : IconTokens.ChevronLeft, size: IconSizeTokens.XL, color: ColorTokens.Grey_Night }))),
                        React.createElement(Space, { size: SizeTypeTokens.MD }))) : (React.createElement(React.Fragment, null)),
                    React.createElement(Typography, { label: title, numberOfLines: 1, fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, fontWeight: '700', fontSize: FontSizeTokens.MD })),
                trailIcon ? (React.createElement(View, { style: {
                        alignItems: 'flex-end',
                        justifyContent: 'center',
                        flex: 1,
                    } },
                    React.createElement(Pressable, { onPress: handleProfileAction, style: {
                        // backgroundColor: ColorTokens.Primary_05,
                        // borderRadius: 15,
                        // padding: 12
                        } },
                        React.createElement(Icon, { name: IconTokens.Account, size: IconSizeTokens.XXXXL, color: ColorTokens.Grey_Night })))) : (React.createElement(React.Fragment, null))),
            !!widgetItem &&
                !!renderItem &&
                renderItem(widgetItem)),
        showBottomLine && React.createElement(View, { style: { height: 0, width: '100%', backgroundColor: 'grey', marginTop: 8 } })));
};
export default memo(HeaderDefaultBase);
export { HeaderDefaultBase };
